// https://vuex.vuejs.org/en/actions.html
import axios from "axios";

export default {
  //
  async sendNumber(data) {
    return axios.post("user/register/", data).then((rsp) => {
      return rsp.data;
    });
  },
};
